module.exports = __webpack_public_path__ + "static/media/paleta.e36f5479.jpeg";